/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { ActionRow, ActionRowButton } from '#components/support/layout/ActionRow/index.jsx';
import { CREATE } from '#constants/pathStrings.js';
import ViewUsersTable from './ViewUsersTable/index.js';

const ViewUsers = (): Element<'div'> => (
  <div>
    <Row>
      <Col md="12">
        <h1>Users</h1>
      </Col>
    </Row>
    <ActionRow>
      <Col md="12" className="col">
        <ActionRowButton className="float-right create-user-button" tag={Link} to={`${CREATE}`}>
          Create User +
        </ActionRowButton>
      </Col>
    </ActionRow>
    <Row>
      <Col md="12">
        <ViewUsersTable />
      </Col>
    </Row>
  </div>
);

export default ViewUsers;
